/* istanbul ignore file */

const PropTypes = require('prop-types');

const cardListItemsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    fullTitle: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    method: PropTypes.string,
    promotion: PropTypes.string,
    className: PropTypes.string,
    rightContent: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
    })
  );


module.exports = {
  frontendData: PropTypes.shape({
    navbar: PropTypes.shape({
      user: PropTypes.shape({
        fullName: PropTypes.string.isRequired, 
        email: PropTypes.string.isRequired,
        avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
      }),
      menuOptions: PropTypes.shape({ 
        title: PropTypes.string.isRequired,
        changeUserLabel: PropTypes.string.isRequired,
        logOutUserLabel: PropTypes.string.isRequired,
      }),
    }),
    pageTitle: PropTypes.string.isRequired,
    backButton: PropTypes.object,
    goToStorePage: PropTypes.func.isRequired,
    goToScreen: PropTypes.func.isRequired,
    paymentByAccountMoney: PropTypes.oneOfType([
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
      PropTypes.oneOf([undefined]),
    ]),
    combination: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }),
    moreThanTwoCards: PropTypes.bool.isRequired,
    rows: cardListItemsPropTypes,
    creditsAndOpenFinance: cardListItemsPropTypes,
    otherPaymentMethods: cardListItemsPropTypes,
    loginSection: PropTypes.shape({
      title: PropTypes.string,
      card: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        pill: PropTypes.string.isRequired,
      }),
    }),
    guestSection: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  }),
};